import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition } from '../../models';
import { IFileManagementService, IStateService, ILoggerService } from '../../services';

class ImageAppContentPickerController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    _iconPath = 'Icons';
    files: File[];
    fileList: FileList;
    progressPercentage: number;
    selectedImage: string;

    static $inject = [
        '$scope',
        'fileManagementService',
        'stateService',
        'loggerService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _fileManagementService: IFileManagementService,
        private _stateService: IStateService,
        private _loggerService: ILoggerService
    ) {

    }

    $onInit() {
        this.progressPercentage = 0;

        this.refresh();

        angular.element('#selectImageModal').on('hidden.bs.modal', _event => {
            this.progressPercentage = 0;
        });

        this._$scope.$watch(() => this.fileList, () => {
            this.upload(this.fileList);
        });
    }

    private buildPath(file) {
        return `/${this._iconPath}/${file.name}`;
    }

    getIconUrl(iconName: string) {
        return this._stateService.getIcon(this.buildPath(iconName));
    }

    select(iconName: string) {
        this.selectedImage = this.buildPath(iconName);
    }

    upload(fileList: FileList) {
        if (fileList && fileList.length) {
            this._fileManagementService
                .upload(fileList[0], 'Content/Icons/')
                .then(_data => {
                    this._loggerService.logSuccess('File uploaded');
                    this.refresh();
                })
                .catch(reason => {
                    this._loggerService.logError('File cannot be uploaded', true, '', reason);
                })
                .finally(() => {
                    this.fileList = undefined;
                });
        }
    }

    private refresh() {
        this._fileManagementService.getContent().then(data => {
            if (data?.directories.push.length > 0) {
                const directory = data.directories.find(d => d.name === this._iconPath);
                this.files = directory.files;
            }
        });
    }
}

export const wtImageAppContentPicker: ComponentDefinition = {
    componentId: 'wtImageAppContentPicker',
    controller: ImageAppContentPickerController,
    template: require('./imageAppContentPicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedImage: '='
    }
};